import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { BookIdentifier } from '@models/BookIdentifier';
import { Canon } from '@models/Canon';
import { CANON_NAMES, getCanon } from '@models/Canons';
import { ProjectConfiguration } from '@models/ProjectConfiguration';
import { UbsBook } from '@models/UbsBook';
import { ChartConfiguration, ChartData, ChartType } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-gloss-votes-donut',
  imports: [
    BaseChartDirective,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule
  ],
  templateUrl: './gloss-votes-donut.component.html',
  styleUrl: './gloss-votes-donut.component.scss'
})
export class GlossVotesDonutComponent implements OnInit {
  @Input() project: ProjectConfiguration | undefined;
  @Input() book: BookIdentifier | undefined;

  scopeControl = new FormControl('');

  // Pie
  public pieChartOptions: ChartConfiguration['options'] = {
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
    },
  };
  public pieChartType: ChartType = 'pie';



  public pieChartData: ChartData<'pie', number[], string> = {
    labels: ['Lexical items with glosses', 'Lexical items without glosses'],
    datasets: [
      {
        data: [401, 4999 - 401],
      },
    ],
  };

  public lexicalItemData: ChartData<'pie', number[], string> | undefined;
  public wordData: ChartData<'pie', number[], string> | undefined;

  constructor(private api: ApiService) {
  }

  ngOnInit(): void {
    if (this.book) {
      this.scopeControl.setValue(this.book.toString());
      this.loadData(this.book.canon, this.book.book);
    }

    this.scopeControl.valueChanges.subscribe(async (value) => {
      const scope = value as Canon | BookIdentifier;
      if (CANON_NAMES.includes(scope as Canon)) {
        this.loadData(scope as Canon);
      } else {
        const bid = BookIdentifier.fromString(scope as string);
        if (bid === undefined) {
          console.error('Invalid BookIdentifier:', scope);
        } else {
          this.loadData(bid.canon, bid.book);
        }
      }
    });
  }

  canonBooks(canon: Canon): UbsBook[] {
    return getCanon(canon).books;
  }

  async loadData(canon: Canon, book?: UbsBook) {
    if (this.project) {
      const result = await this.api.getStats(this.project?.id, canon, book);

      this.lexicalItemData = {
        labels: ['Lexical items with glosses', 'Lexical items without glosses'],
        datasets: [
          {
            data: [result.lexicalItems.with, result.lexicalItems.without],
          },
        ],
      };

      this.wordData = {
        labels: ['Words with glosses and votes', 'Words that only need votes', 'Words that still need glosses'],
        datasets: [
          {
            data: [result.words.with, result.words.potential, result.words.without],
          },
        ],
      };
    }
  }

  makeBookIdentifier(canon: Canon, book: UbsBook): string {
    return new BookIdentifier(book, canon).toString();
  }
}
